module.exports = __webpack_public_path__ + "img/icon_tishi@3x.c7cb06ce.png";